import React, {useEffect, useState} from 'react';
import Select from "react-select";
import styled from "styled-components";

const MainDiv=styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;

    background: rgba(0, 0, 0, 0.7);

    display: flex;
    flex-direction: column;
    align-items: center;
`
const Canvas=styled.canvas`
    display: none;
`
const Video=styled.video`
    width: 90%;
    height: 80%;
    object-fit: contain;
    margin: 0 auto;
`
const SelectDevice=styled(Select)`
    margin: 10px auto;    
    width: 80%;
`
const Button=styled.button`
    position: fixed;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);

    width: 72px;
    height: 72px;
    border-radius: 50%;

    border: 4px solid white;
    background: rgba(255, 255, 255, 0.2);

    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    transition: all 0.2s ease;

    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.35);

    &:hover {
        transform: translateX(-50%) scale(1.08);
        background: rgba(255, 255, 255, 0.3);
    }

    &:active {
        transform: translateX(-50%) scale(0.92);
    }

    &::after {
        content: "";
        width: 52px;
        height: 52px;
        border-radius: 50%;
        background: white;
    }
`
const Camera = ({setPicture, setCameraOpen}) => {
    const [video, setVideo]=useState();
    const canvas = document.querySelector('canvas');
    const [VideoDevices, setVideoDevices]=useState([]);
    const [Device, setDevice]=useState(null);
    const [GetPictureInterval, setGetPictureInterval]=useState();

    const constraints = {
        video: {
             width:{ideal:1920},
             height:{ideal:1080}
        }
    };

    function ChangeVideoDevice(value) {
        const updatedConstraints = {
            // ...constraints,
            video:{
                 ...constraints.video,
                deviceId: {
                    exact:  value.value
                }
            }
        };
        setDevice(value)
        startStream(updatedConstraints);
    };

    async function startStream  (constraints) {
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        video.srcObject = stream;
    };
    async function start(){
        const res=await startStream(constraints);
    }

    async function getDevices() {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(device => device.kind === 'videoinput');
        let temp=[];
        videoDevices.map(el=>{
            temp=[...temp, {value:el.deviceId, label:el.label}]
        })
        setVideoDevices(temp);
        setDevice(temp[0])
    }

    function doScreenShot(event){
        event.stopPropagation();
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0);
        // setPicture(canvas.toDataURL());
        canvas.toBlob((blob) => {
            setPicture(blob)

        }, 'image/png',1);
    };
    function closeCamera() {
        if (video?.srcObject) {
            video.srcObject.getTracks().forEach(track => track.stop());
        }
        video.srcObject = null;
        setCameraOpen(false);
    }
    // request camera permission
    navigator.mediaDevices.getUserMedia({video: true})

    useEffect(()=>{
        setVideo(document.getElementById("video"));
    },[])
    useEffect(()=>{
        if(video)
            start();
    },[video])
    useEffect(()=>{
        getDevices()
    },[])

    return (
        <MainDiv>
            <SelectDevice value={Device} options={VideoDevices} onChange={ChangeVideoDevice}/>
            <Video id="video" autoPlay onClick={closeCamera}/>
            <Button title="ScreenShot"  onClick={doScreenShot}/>
            <Canvas/>
        </MainDiv>
    );

};

export default Camera;